export default "__VITE_ASSET__SWc8LcBh__"